import ROUTES, { RenderRoutes } from "./routes";
import { AuthProvider, AuthService } from "react-oauth2-pkce";
import LoginPage from "./modules/common/pages/LoginPage";
import { IntlProvider } from "react-intl";
import messagesInPortuguese from "./lang/pt-BR.json";
import { ThemeProvider } from "@material-ui/core";
import { theme } from "./theme";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback, UserBar, DarkModeProvider } from "@funcional/react-ui";
import {
  PermissionProvider,
  JwtUser,
  jwtToUser,
} from "@funcional/react-auth-ui";
import { useLocation } from "react-router-dom";
import { fetchPermission } from "@common/helpers/fetch-permission";

const authService = new AuthService({
  clientId:
    process?.env?.REACT_APP_SSO_OAUTH_CLIENT_ID ||
    window?.environment?.REACT_APP_SSO_OAUTH_CLIENT_ID ||
    "0",
  location: window.location,
  provider: `${
    process?.env?.REACT_APP_SSO_URL || window?.environment?.REACT_APP_SSO_URL
  }/oauth2`,
  redirectUri: window.location.origin,
  scopes: (
    process?.env?.REACT_APP_SSO_OAUTH_SCOPES ||
    window?.environment?.REACT_APP_SSO_OAUTH_SCOPES ||
    "name,profiles"
  ).split(","),
});

function detectModuleName(pathname: string) {
  if (pathname.startsWith("/pbm")) return "Programas de PBM";
  if (pathname.startsWith("/sso")) return "Single Sign On";
  if (pathname.startsWith("/refund")) return "Reposição";
}

function App() {
  let user: JwtUser | undefined = undefined;
  const location = useLocation();
  const moduleName = detectModuleName(location.pathname);

  try {
    if (authService.isAuthenticated()) {
      user = jwtToUser(authService.getAuthTokens()?.access_token);
    }
  } catch (error) {
    console.log(error);
  }

  return (
    <DarkModeProvider>
      <ThemeProvider theme={theme}>
        <IntlProvider
          messages={messagesInPortuguese}
          locale="pt-BR"
          defaultLocale="pt-BR"
        >
          <AuthProvider authService={authService}>
            {user ? (
              <PermissionProvider fetchPermission={fetchPermission(user)}>
                <>
                  <UserBar
                    moduleName={moduleName}
                    userName={user.name}
                    onLogout={() => authService.logout()}
                  />

                  <ErrorBoundary
                    FallbackComponent={ErrorFallback}
                    resetKeys={[location]}
                  >
                    <RenderRoutes routes={ROUTES} />
                  </ErrorBoundary>
                </>
              </PermissionProvider>
            ) : (
              <LoginPage />
            )}
          </AuthProvider>
        </IntlProvider>
      </ThemeProvider>
    </DarkModeProvider>
  );
}

export default App;
